export default __webpack_public_path__ + "static/media/flipkart-call-image.5f810e47.svg";